(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-styling-snap"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function updateArrows(section, scroller) {
      var overflow = scroller.scrollWidth > scroller.clientWidth + 2;
      section.querySelectorAll('[data-snap-arrow]').forEach(function (b) {
        b.style.display = overflow ? '' : 'none';
      });
    }
    function initSection(section) {
      if (section.dataset.bpSnapInit === '1') { return; }
      section.dataset.bpSnapInit = '1';
      var scroller = section.querySelector('[data-snap-scroller]');
      if (!scroller) { return; }
      section.querySelectorAll('[data-snap-arrow]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-snap-arrow') === 'next' ? 1 : -1;
          scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      updateArrows(section, scroller);
      window.addEventListener('resize', function () { updateArrows(section, scroller); });
    }
    function initAll() {
      document.querySelectorAll('[data-section-type="bluepalang-snap"]').forEach(initSection);
    }
    initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target && e.target.querySelector ? e.target.querySelector('[data-section-type="bluepalang-snap"]') : null;
      if (sec) { sec.dataset.bpSnapInit = ''; initSection(sec); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styling-snap"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LOOP_SECONDS = 3;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setupVideo(v) {
      if (v.dataset.igVideoInit === '1') { return; }
      v.dataset.igVideoInit = '1';
      v.muted = true; // 自動再生に必須
      // 冒頭 LOOP_SECONDS 秒だけ繰り返す
      v.addEventListener('timeupdate', function () {
        if (v.duration && v.duration > LOOP_SECONDS && v.currentTime >= LOOP_SECONDS) {
          v.currentTime = 0;
        }
      });
    }

    function updateArrows(section, scroller) {
      var overflow = scroller.scrollWidth > scroller.clientWidth + 2;
      section.querySelectorAll('[data-ig-arrow]').forEach(function (b) {
        b.style.display = overflow ? '' : 'none';
      });
    }

    function initSection(section) {
      if (section.dataset.igInit === '1') { return; }
      section.dataset.igInit = '1';

      var videos = section.querySelectorAll('[data-ig-video]');
      videos.forEach(setupVideo);
      if (!reduceMotion && videos.length) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var v = e.target;
              if (e.isIntersecting) { v.play().catch(function () {}); }
              else { v.pause(); }
            });
          }, { threshold: 0.25 });
          videos.forEach(function (v) { io.observe(v); });
        } else {
          videos.forEach(function (v) { v.play().catch(function () {}); });
        }
      }

      var scroller = section.querySelector('[data-ig-scroller]');
      if (!scroller) { return; }
      section.querySelectorAll('[data-ig-arrow]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-ig-arrow') === 'next' ? 1 : -1;
          scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      updateArrows(section, scroller);
      window.addEventListener('resize', function () { updateArrows(section, scroller); });
    }

    function initAll() {
      document.querySelectorAll('[data-section-type="bluepalang-ig"]').forEach(initSection);
    }
    initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target && e.target.querySelector ? e.target.querySelector('[data-section-type="bluepalang-ig"]') : null;
      if (sec) { sec.dataset.igInit = ''; initSection(sec); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
